import styled from "styled-components";

export const RequestFeedbackStyled = styled.div`
    text-align: center;
    
    .btn {
        width: 100%;
    }
`;

export const RequestFeedbackStarsStyled = styled.div`
    color: var(--color-button-primary-default);
    font-size: 21px;
    display: flex;
    flex-direction: row;
    gap: 4px;
    justify-content: center;
    margin-bottom: 16px;
`;

export const RequestFeedbackLogoStyled = styled.div`
    background: linear-gradient(225.42deg, #FFDAB9 -8.1%, #FFEF7D 16.46%, #FFFC57 48.19%, #F0FC69 82.93%, #C0FCA3 106.88%);
    border-radius: 50%;
    width: 40px;
    height: 40px;
    line-height: 38px;
    margin: 0 auto 16px;
    
    img {
        width: 24px;
    }
`;
